/**
 * The words of a 402 ("Your trial has expired…", "Package purchased but not yet active") are for the person's Billing page, which the
 * api interceptor opens. The new frame shows the same state in its own strip, so a red toast with the server's words on top repeats it
 * (walkthrough decision 5). The interceptor notes the words here; the toast host skips them inside the new frame.
 */
const seen = new Map<string, number>();
const WINDOW_MS = 15000;

export const noteBillingRefusal = (message: unknown): void => {
  if (typeof message === "string" && message) seen.set(message, Date.now());
};

export const isBillingRefusalMessage = (message: unknown): boolean => {
  if (typeof message !== "string") return false;
  const at = seen.get(message);
  return at !== undefined && Date.now() - at < WINDOW_MS;
};
